import aiStudioImage from "@/assets/login/ai-studio.webp";
import fullyManagedPlansImage from "@/assets/login/fully-managed-plans.webp";
import whiteLabelWorkspaceImage from "@/assets/login/white-label-workspace.webp";

export interface LoginPromoSlide {
  badge: string;
  body: string;
  headline: string;
  href: string;
  image: string;
}

export const LOGIN_PROMO_SLIDES: LoginPromoSlide[] = [
  {
    badge: "What's new",
    body: "Give your clients a professional, agency-branded workspace to submit requests, collaborate, and review work. We power the production with our designer network and delivery infrastructure, while you remain the face of the relationship.",
    headline: "Your own white label platform, built for your agency.",
    href: "https://nlc.com/white-label-design",
    image: whiteLabelWorkspaceImage,
  },
  {
    badge: "What's new",
    body: "The most hands-off, high-output creative experience we offer. Your team focuses on the business. Ours handles the rest.",
    headline:
      "Let us take over the entire creative process for you with our fully managed plans.",
    href: "https://nlc.com/fully-managed-design",
    image: fullyManagedPlansImage,
  },
  {
    badge: "What's new",
    body: "Say goodbye to spending thousands of dollars on professional assets and let our AI team of experts create them for you.",
    headline:
      "Now offering custom AI asset generation capabilities to cover all your needs.",
    href: "https://nlc.com/our-work/ai-studio",
    image: aiStudioImage,
  },
];
